// mutations
const SET_RESMEMBER = (state, payload) => {
  state.res_member = payload;
};
const SET_PAGINATION = (state, payload) => {
  state.page = payload;
};
const SET_SEARCH = (state, payload) => {
  state.search = payload;
};
const SET_IDUSER = (state, payload) => {
  state.idUser = payload;
};
const SET_DATAACCESS = (state, payload) => {
  state.temp_access = payload;
};
export default {
  SET_RESMEMBER,
  SET_PAGINATION,
  SET_SEARCH,
  SET_IDUSER,
  SET_DATAACCESS
};
